import React, { useState } from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';

import { useAuth } from 'contexts/AuthContext';
import SendMessageIcon from '../Support/icons/SendMessageIcon';
import { InvitationsPanel } from './InvitationsPanel';

// Header button for "Manage invitations": the invites addressed to the signed-in user, live
// from AuthContext, with a count badge. Shared by the resident header and the manager header,
// because a manager can be invited as a resident or guest, or to another org's team, and the
// panel is the only place in the app to accept or decline it.
export function InvitationsButton() {
    const { userInvites } = useAuth();
    const [anchorEl, setAnchorEl] = useState(null);
    const invitationCount = userInvites.length;

    return (
        <>
            {/* Hidden while the panel is open, so it does not sit on top of it. */}
            <Tooltip title={anchorEl ? '' : 'Invitations'}>
                <IconButton
                    aria-label="Manage invitations"
                    onClick={event => setAnchorEl(event.currentTarget)}
                    sx={{
                        bgcolor: '#f8f8f8',
                        border: '0.762px solid #dedede',
                        borderRadius: '999px',
                        width: '32px',
                        height: '32px',
                        minWidth: '32px',
                        p: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        position: 'relative',
                        '&:hover': {
                            bgcolor: '#efefef'
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: 18,
                            height: 18,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <SendMessageIcon size={16} color="#212322" />
                    </Box>
                    {invitationCount > 0 && (
                        <Box
                            data-testid="invitations-badge"
                            sx={{
                                position: 'absolute',
                                top: '-5px',
                                left: '-2px',
                                width: '14px',
                                height: '14px',
                                bgcolor: '#33C78F',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontWeight: 600,
                                    fontSize: '8.5px',
                                    lineHeight: '6.857px',
                                    color: 'white'
                                }}
                            >
                                {invitationCount}
                            </Typography>
                        </Box>
                    )}
                </IconButton>
            </Tooltip>

            <InvitationsPanel anchorEl={anchorEl} onClose={() => setAnchorEl(null)} />
        </>
    );
}

export default InvitationsButton;
